// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import { getAuth } from "firebase/auth";
import { getStorage } from "firebase/storage";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyCp8UF56DUVkEJG4cOflGTEFl1ivQjzWJY",
  authDomain: "sexeducation-c0902.firebaseapp.com",
  projectId: "sexeducation-c0902",
  storageBucket: "sexeducation-c0902.firebasestorage.app",
  messagingSenderId: "305914583809",
  appId: "1:305914583809:web:587408614de793c339d900",
  measurementId: "G-65YF35TNK6"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const db = getFirestore(app);
const auth = getAuth(app);
const storage = getStorage(app);

export { db, auth, storage };

